module.exports = __webpack_public_path__ + "static/media/dot.cbf4af1d.svg";